import { render, staticRenderFns } from "./DraftFormProduct.vue?vue&type=template&id=e22ca3b6&scoped=true&"
import script from "./DraftFormProduct.vue?vue&type=script&lang=js&"
export * from "./DraftFormProduct.vue?vue&type=script&lang=js&"
import style0 from "./DraftFormProduct.vue?vue&type=style&index=0&id=e22ca3b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22ca3b6",
  null
  
)

export default component.exports